import {
	useParams,
	useNavigate
} from "react-router-dom";
import React, {
	useEffect,
	useState
} from "react";

import {
	doc,
	getDoc,
	setDoc,
	serverTimestamp
} from "firebase/firestore";

import { db }
from "../firebase/firebaseConfig";

import {
	useAuth
}
from "../contextos/AuthContext";

import {
	collection,
	getDocs
}
from "firebase/firestore";
import styled from "styled-components";
const TemaPortal = () => {

	const {
		codigo,
		componenteId,
		temaId
	} = useParams();

    const navigate =
	useNavigate();

    const tipoQuiz = {

        icfes: "Examen_Icfes",
    
        unal: "Examen_Unal",
    
        udea: "Examen_Udea"
    
    }[codigo];

    const [tema, setTema] =
	useState(null);

    const [progreso, setProgreso] =
	useState(null);

    const {
        usuario
    } = useAuth();

    useEffect(() => {

        const cargarTema =
        async () => {
    
            const snap =
                await getDoc(
                    doc(
                        db,
                        "materias_temas",
                        String(temaId)
                    )
                );
    
            if (
                snap.exists()
            ) {
    
                setTema(
                    snap.data()
                );
                const progresoSnap =
                    await getDocs(
                        collection(
                            db,
                            "progreso_temas"
                        )
                    );

                const progresoTema =
                    progresoSnap.docs
                        .map(d => d.data())
                        .find(
                            p =>
                            Number(
                                p.temaId
                            ) ===
                            Number(
                                temaId
                            )
                            &&
                            p.userId ===
                            usuario.uid
                        );

                setProgreso(
                    progresoTema || null
                );
            }
        };
    
        cargarTema();
    
    }, [temaId]);

    if (!tema) {

        return (
    
            <div
                style={{
                    padding: "2rem",
                    color: "white"
                }}
            >
                Cargando tema...
            </div>
        );
    }
    const respondidas =
        progreso?.totalRespondidas || 0;

    const progresoExploracion =
            Math.min(
                100,
                Math.round(
                    (respondidas / 5) * 100
                )
        );

        let nivelExplorador = 1;

        if (
            respondidas >= 10
        ) {
            nivelExplorador = 2;
        }
    
        if (
            respondidas >= 25
        ) {
            nivelExplorador = 3;
        }
    
        if (
            respondidas >= 50
        ) {
            nivelExplorador = 4;
        }
    
        let rango =
            "🌱 Novato";

        if (
            nivelExplorador >= 2
        ) {
            rango =
                "📡 Explorador";
        }

        if (
            nivelExplorador >= 3
        ) {
            rango =
                "🔥 Conquistador";
        }

        if (
            nivelExplorador >= 4
        ) {
            rango =
                "👑 Maestro";
        }


    const correctas =
        progreso?.correctas || 0;

    const precision =
        respondidas
            ? Math.round(
                (correctas / respondidas)
                * 100
            )
            : 0;

            const misionCompletada =
            respondidas >= 5 &&
            precision >= 70;

            const recompensaDisponible =
	misionCompletada &&
	!progreso?.recompensaReclamada;
        
        const faltaPractica =
            respondidas < 5;
        
        const necesitaRefuerzo =
            respondidas >= 5 &&
            precision < 70;        

            let diasSinRepasar = 0;


if (
	progreso?.ultimaEvaluacion
) {

	diasSinRepasar =
		Math.floor(
			(
				Date.now()
				-
				progreso
					.ultimaEvaluacion
					.toDate()
					.getTime()
			)
			/
			(1000 * 60 * 60 * 24)
		);
}


const desgaste =
	Math.floor(
		diasSinRepasar / 7
	) * 5;


const dominioReal =
	Math.max(
		0,
		precision - desgaste
	);


let estadoTema =
	"⚪ Sin descubrir";


if (respondidas > 0) {

	estadoTema =
		"⚔️ En batalla";
}


if (
	respondidas >= 5 &&
	dominioReal >= 85
) {

	estadoTema =
		"👑 Conquistado";
}


if (
	respondidas >= 5 &&
	dominioReal >= 70 &&
	dominioReal < 85
) {

	estadoTema =
		"⚔️ Estable";
}


if (
	respondidas >= 5 &&
	dominioReal >= 50 &&
	dominioReal < 70
) {

	estadoTema =
		"⚠️ Necesita repaso";
}


if (
	respondidas >= 5 &&
	dominioReal < 50
) {

	estadoTema =
		"⚠️ Debilitado";
}
            
	return (

        <div
            style={{
                padding: "2rem",
                color: "white"
            }}
        >
    
            <h1>
                📚 {tema.Tema}
            </h1>

            <h2>

{
	misionCompletada
		? "👑 Tema conquistado"
		: "⚔️ Misión activa"
}

</h2>

            <p>

                🧭 Nivel Explorador
                {" "}
                {nivelExplorador}

            </p>

            <p>
                {rango}
            </p>

            <h2>
                {estadoTema}
            </h2>

            <Barra>

            <BarraFill
                valor={
                    progresoExploracion
                }
            />

            </Barra>

            <p>

            Dominio:
{" "}
{dominioReal}%

            </p>
    
            <p>
                🏛️ {tema.Materia}
            </p>
    
            <p>
                🧭 {tema.Macrotema}
            </p>
    
            <br />
    
            <h3>
                Descripción
            </h3>
    
            <p>
                {tema.Descripcion_breve}
            </p>
    
            <br />
    
            <h3>

🏆 Estado de conquista

</h3>

<p>

🎁 Recompensa por conquista:
+50 XP
+25 Yutokens

</p>

<p>

{
	misionCompletada
		? "👑 Conquistado"
		: respondidas >= 5
		? "⚔️ En combate"
		: "📡 Explorando"
}

</p>

            <p>
                🎓 Grado:
                {" "}
                {tema.Grado}
            </p>
    
            <p>
                🔗 Prerrequisitos:
                {" "}
                {tema.Prerrequisitos?.length || 0}
            </p>

            <hr />

            <h3>
	{
		misionCompletada
			? "🏆 Misión completada"
			: "🎯 Misión actual"
	}
</h3>

<p>

{
	misionCompletada
		? "Has conquistado este conocimiento. Pero recuerda: el conocimiento se debilita con el tiempo."
		: faltaPractica
		? `Completa ${5 - respondidas} entrenamientos para dominar esta zona.`
		: "Tu dominio aún no es suficiente. Refuerza para conquistar la zona."
}

</p>

<p>

{
	misionCompletada
		? "⭐ Dominio alcanzado"
		: "⚔️ En progreso"
}

</p>

<p>
	⚔️ Dominio actual:
	{" "}
	{precision}%
</p>

<p>
	🔥 Racha de entrenamiento:
	{" "}
	{respondidas}
	/5
</p>

<p>

	🎁 Cofre:

	{" "}

	{
		recompensaDisponible
			? "✨ Disponible"
			: misionCompletada
			? "Abierto ✅"
			: "Bloqueado 🔒"
	}

</p>

{
	recompensaDisponible && (

		<button

	onClick={async () => {

		const ref = doc(
			db,
			"progreso_temas",
			`${usuario.uid}_${tema.ID}`
		);

		await setDoc(
			ref,
			{

				recompensaReclamada:
					true,

				fechaRecompensa:
					serverTimestamp()

			},
			{
				merge: true
			}
		);

		setProgreso(
			prev => ({
				...prev,
				recompensaReclamada:
					true
			})
		);

		alert(
			"🎁 Cofre abierto\n\n⚡ +50 XP\n💰 +25 Yutokens\n🏆 Tema conquistado"
		);

	}}

>

	🎁 Abrir cofre

</button>
	)
}
            <br />

            <button

	onClick={() => {

		navigate(
            `/quiz/${tipoQuiz}?tema=${tema.ID}&componente=${componenteId}&examen=${codigo}`
        );

	}}

>

	🚀 Entrenar misión

</button>
    
        </div>
    );
};

export default TemaPortal;

const Barra =
styled.div`

	height: 16px;

	background:
		rgba(
			255,
			255,
			255,
			0.12
		);

	border-radius: 999px;

	overflow: hidden;

	margin: 1rem 0;
`;

const BarraFill =
styled.div`

	height: 100%;

	width:
		${props =>
			props.valor}%;
	
	background:
		linear-gradient(
			90deg,
			#00F2FF,
			#00FF95
		);

	transition:
		.4s ease;
`;